import React from 'react';
import {
  VStack,
  Select,
  SelectTrigger,
  SelectInput,
  SelectIcon,
  SelectPortal,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicatorWrapper,
  SelectDragIndicator,
  SelectItem,
  Icon,
  ChevronDownIcon,
  Button,
  ButtonText,
  HStack,
} from '@gluestack-ui/themed';

const StateChangeSelector = ({
  states, onConfirm, onCancel, isLoading = false,
}) => {
  const [selectedState, setSelectedState] = React.useState(states[0]?.id);

  return (
    <VStack space="lg" mt="$4">
      <Select
        selectedValue={selectedState}
        onValueChange={(value) => setSelectedState(value)}
      >
        <SelectTrigger variant="outline" size="md">
          <SelectInput placeholder="Select state" />
          <SelectIcon mr="$3">
            <Icon as={ChevronDownIcon} />
          </SelectIcon>
        </SelectTrigger>
        <SelectPortal>
          <SelectBackdrop />
          <SelectContent>
            <SelectDragIndicatorWrapper>
              <SelectDragIndicator />
            </SelectDragIndicatorWrapper>
            {states.map((state) => (
              <SelectItem key={state.id} label={state.label} value={state.id} />
            ))}
          </SelectContent>
        </SelectPortal>
      </Select>

      <HStack space="md" justifyContent="flex-end" mt="$4">
        <Button variant="outline" action="secondary" onPress={onCancel} isDisabled={isLoading}>
          <ButtonText>Cancel</ButtonText>
        </Button>
        <Button
          action="primary"
          onPress={() => onConfirm(selectedState)}
          isDisabled={!selectedState || isLoading}
        >
          <ButtonText>Confirm Change</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
};

export default StateChangeSelector;
